import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { waLink } from "@/lib/site";
import { useScrollTo } from "./SmoothScroll";

const WaIcon = () => (
  <svg viewBox="0 0 32 32" className="h-7 w-7" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C8.86 3 3.02 8.83 3.02 16c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.74A13 13 0 0 0 16.04 29C23.2 29 29 23.17 29 16S23.2 3 16.04 3zm0 23.6c-1.98 0-3.92-.53-5.6-1.54l-.4-.24-3.96 1.03 1.06-3.86-.26-.4A10.6 10.6 0 1 1 26.64 16c0 5.85-4.76 10.6-10.6 10.6zm5.82-7.94c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.56-1.58-.95-.85-1.59-1.89-1.77-2.21-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.71-1.71-.98-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65s1.14 3.08 1.3 3.29c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export const FloatingActions = () => {
  const [show, setShow] = useState(false);
  const scrollTo = useScrollTo();
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {show && (
          <motion.button
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            onClick={() => scrollTo(0)}
            data-testid="scroll-to-top-button"
            aria-label="Scroll to top"
            className="glass flex h-11 w-11 items-center justify-center rounded-full text-white transition-colors hover:text-[var(--gold)]"
          >
            <ArrowUp className="h-4 w-4" />
          </motion.button>
        )}
      </AnimatePresence>
      <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp-button" aria-label="Chat with Pratap Group on WhatsApp" className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_15px_40px_-10px_rgba(37,211,102,.7)] transition-transform duration-300 hover:scale-110">
        <span className="ping-soft absolute inset-0 rounded-full bg-[#25D366]" />
        <span className="relative"><WaIcon /></span>
        <span className="pointer-events-none absolute right-16 whitespace-nowrap rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-black opacity-0 transition-opacity duration-300 group-hover:opacity-100">Chat with us</span>
      </a>
    </div>
  );
};
